<template>
  <div>
    <v-dialog v-model="show" persistent width="800">
      <v-card>
        <v-app-bar flat color="primary" class="white--text" dense>
          <v-toolbar-title>Movimientos justificante</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon class="white--text" @click="$emit('update:show', false)">mdi-close</v-icon>
        </v-app-bar>
        <v-card-text class="py-2">
          <div class="text-subtitle-1">{{nombre}}</div>
          <div class="text-subtitle-1">{{tipoJustificante}}</div>
          <v-data-table
            :headers="headerMov"
            :items="movs"
            disable-sort
            dense
            :items-per-page="5"
            :hide-default-footer="hideFooterMov"
            :footer-props="footerProps"
            class="elevation-1"
          >
            <template v-slot:item.fechaRegistro="{ item }">
              {{ formatFec(item.fechaRegistro) }}
            </template>
            <template v-slot:item.motivo="{ item }">
              <span v-if="haveMore(item.motivo)" @mouseover.capture.stop="showMotivo($event, item.motivo)" @mouseleave.capture.stop="hideMotivo()">
                {{ formatMotivo(item.motivo) }}
                <span class="text-caption success--text" >
                  mas
                </span>
              </span>
              <span v-else>
                {{ item.motivo }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="$emit('update:show', false)">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu :value="verMotivo" :position-x="posX" :position-y="posY">
      <v-card width="400" flat>
        <v-card-text class="pa-2">
            <span class="font-weight-medium">{{mensajeMotivo}}</span>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }, 
    nombre: {
      type: String
    }, 
    tipoJustificante: {
      type: String
    }, 
    movs: {
      type: Array
    }
  },
  data() {
    return {
      headerMov: [
        { text: 'Estatus', value: 'estatus', class: "accent white--text"},
        { text: 'Fecha registro', value: 'fechaRegistro', class: "accent white--text"},
        { text: 'Usuario', value: 'nombreUsuario', class: "accent white--text"},
        { text: 'Observaciones', value: 'motivo', class: "accent white--text"},
      ],
      footerProps: {
        disableItemsPerPage: true,
      },
      posX: 0,
      posY: 0,
      verMotivo: false,
      mensajeMotivo: null
    }
  },
  computed: {
    hideFooterMov() {
      let hide = true;
      if (this.movs) {
        hide = this.movs.length < 6;
      }
      return hide;
    },
  },
  methods: {
    formatFec(fecha) {
      if (!fecha) return ""
      const [year, month, day] = fecha.substr(0,10).split('-');
      const hr = fecha.substr(11,8);
      return `${day}/${month}/${year} ${hr}`
    },
    formatMotivo(motivo) {
      let ver = "";
      if (motivo) {
        if (motivo.length > 35) {
          ver = motivo.substr(0, 33)+ "...";
        } else {
          ver = motivo;
        }
      }
      return ver;
    },
    haveMore(motivo) {
      let hay = motivo && motivo.length > 35;
      return hay;
    },
    showMotivo(event, mensaje) {
      if (!this.verMotivo) {
        this.posX = event.clientX+ 30;
        this.posY = event.clientY;
        this.mensajeMotivo = mensaje;
        this.verMotivo = true;
      }
    },
    hideMotivo() {
      if (this.verMotivo) {
        this.mensajeMotivo = null;
        this.verMotivo = false;
      }
    }
  }
}
</script>